import { Annoncement } from '@Models';
import { buildEntityState, EntityState } from '../EntityState';

export type AnnoncementState = EntityState<Annoncement> & {
  hidden: boolean;
};

export const buildAnnoncementState = (
  data: Partial<AnnoncementState> = {},
) => ({
  ...buildEntityState<Annoncement>(data),
  hidden: data.hidden ?? false,
});
